import React from "react";
import Slider from "react-slick";

const Carousel = ({children, slidesToScroll = 1, slidesToShow = 1, className, speed = 500, ...props}) => {
  const params = {
    dots: true,
    infinite: true,
    speed,
    arrows: false,
    slidesToShow,
    slidesToScroll,
    // adaptiveHeight: true,
    appendDots: dots => <ul className="custom-dots">{dots}</ul>,
  };

  const settings = {
    ...params,
    ...props
  }

  return (
    <div className={`${className && className}`}>
      <Slider {...settings}>
        {children}
      </Slider>
    </div>
  )
}

export { Carousel }
